import { MatchableItem, MatchableTransaction, MatchItemType } from "../types";
import { TransactionLedgerContexts } from "./transactionLedgerContexts";

export const CROSS_ENTITY_BILL_REQUIRES_ACCRUAL_LEDGER_REASON =
    "Matching a bill from another entity requires an accrual ledger";

export function getCrossEntityBillBlockedTransactionIds({
    document,
    transactions,
    contextsByTransactionId,
}: {
    document: Pick<MatchableItem, "type" | "entityId">;
    transactions: ReadonlyArray<Pick<MatchableTransaction, "id" | "entity">>;
    contextsByTransactionId: TransactionLedgerContexts;
}): number[] {
    if (document.type !== MatchItemType.BILL) {
        return [];
    }
    return transactions
        .filter(
            (transaction) =>
                transaction.entity.id !== document.entityId &&
                !contextsByTransactionId.get(transaction.id)?.hasAccrualLedger,
        )
        .map((transaction) => transaction.id);
}
